import { useRef, useState, useEffect } from "react";
import { Play, Pause } from "lucide-react";

// Vertical phone-frame video player (click to play inline, with sound).
export const PhoneVideo = ({ src, poster, label = "Portals of Awe", testid = "phone-video", autoPlay = false }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(autoPlay);
  const [muted, setMuted] = useState(autoPlay);

  useEffect(() => { if (ref.current) ref.current.muted = muted; }, [muted]);

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) { v.play().catch(() => {}); setPlaying(true); }
    else { v.pause(); setPlaying(false); }
  };

  return (
    <div className="relative">
      <div className="absolute -inset-8 radial-glow blur-2xl pointer-events-none" />
      <div className="relative w-[260px] h-[540px] rounded-[2.5rem] bg-[#05070C] ring-gold-frame p-3">
        <div className="w-full h-full rounded-[2rem] overflow-hidden relative bg-black bg-cover bg-center cursor-pointer"
          style={poster ? { backgroundImage: `url(${poster})` } : undefined}
          onClick={toggle} data-testid={testid}>
          <video ref={ref} src={src} poster={poster} playsInline preload="metadata"
            autoPlay={autoPlay} muted={autoPlay} loop={autoPlay}
            className="absolute inset-0 w-full h-full object-cover"
            onEnded={() => { if (!autoPlay) setPlaying(false); }} onError={(e) => { e.currentTarget.style.opacity = 0; }} />
          <div className="absolute top-2 left-1/2 -translate-x-1/2 w-20 h-5 bg-black rounded-full z-10" />
          {!playing && (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-black/25 z-10">
              <div className="w-16 h-16 rounded-full btn-gold flex items-center justify-center animate-pulse-glow">
                <Play size={26} className="ml-1 text-[#14100A]" fill="#14100A" />
              </div>
            </div>
          )}
          {playing && (
            <button data-testid={`${testid}-pause`} aria-label="Pause video" onClick={(e) => { e.stopPropagation(); toggle(); }}
              className="absolute bottom-4 right-4 z-10 w-11 h-11 rounded-full bg-black/55 backdrop-blur flex items-center justify-center text-[#E7CC86] opacity-0 hover:opacity-100 transition-opacity">
              <Pause size={18} fill="currentColor" />
            </button>
          )}
        </div>
      </div>
      <p className="mt-4 text-center text-[#E7CC86] text-xs tracking-[0.2em] uppercase">{label}</p>
    </div>
  );
};
